import Request from '../../common/api/request';
import ServiceResultFactory from '../../common/api/ServiceResultFactory';

const showPlanUrl = (baseUrl, eventEditionId, showPlanningId) =>
  `${baseUrl}/v1/event-editions/${eventEditionId}/show-plan/${showPlanningId}`;

const getShowPlan = (baseUrl, eventEditionId, showPlanningId) => {
  const baseApiUrl = baseUrl.endsWith('/')
    ? baseUrl.substring(0, baseUrl.length - 1)
    : baseUrl;

  const url = showPlanUrl(baseApiUrl, eventEditionId, showPlanningId);

  return Request.get(url)
    .then((response) => {
      const showPlan = response.body || {};
      if (!Array.isArray(showPlan.exhibitorIds)) showPlan.exhibitorIds = [];
      if (!Array.isArray(showPlan.productIds)) showPlan.productIds = [];
      return ServiceResultFactory.fromSuccess({ showPlan });
    })
    .catch((result) => {
      if (result.status === 404) {
        return { showPlan: { exhibitorIds: [], productIds: [] } };
      }
      return ServiceResultFactory.fromError(result);
    });
};

export default { getShowPlan };
